import {CanActivateChildFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../services/auth/auth.service";
import {map} from "rxjs/operators";

export const userGuard: CanActivateChildFn = (childRoute, state) => {
  const router = inject(Router);
  const isLoggedIn = inject(AuthService).isLoggedIn();
  if("boolean" === typeof isLoggedIn) return isLoggedIn;
  return isLoggedIn.pipe(map(
    (value) => {
      if(!value) {
        return router.createUrlTree(["/login"]);
      }
      return value;
    }
  ));
};
